import { Box, Button, CircularProgress, Typography, withStyles } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import Styles from "../commonStyles";
import { validateUsername } from "../validation/validator";
import { userActions } from "../_actions";
import AuthContainer from "../_components/AuthContainer";
import CommonPopup from "../_components/CommonPopup";
import InputPaper from "../_components/InputPaper";
import config from "../_config/config";
import strings from "../_constants/strings";
import { isCTCL, setCookieNew, setReferer } from "../_helpers/cookies";
import { goBackToReferer, gotoChangePassword, goToDIY, goToEnterPin, gotoForgotPassword, gotoLoginWithOtp, gotoLoginWithTotp } from "../_helpers/navHelpers";
import { a11yProps } from "./components/Tabs/helper";
import { StyledTab } from "./components/Tabs/StyledTab";
import { StyledTabs } from "./components/Tabs/StyledTabs";

class Login extends React.Component {
  constructor(props) {
    super(props);
    // rest login status
    this.props.dispatch(userActions.logout());
    this.state = {
      username: "",
      password: "",
      submitting: false,
      isforgotpassword: false,
      isFirstLogin: false,
      // isFirstLogin: true,
      alert: { message: null },
      isEditing: false,
      showImage: true,
      tabValue: this.isRegUser() ? 1 : 0
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    setReferer();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      !prevState.isEditing && nextProps.alert.message &&
      nextProps.alert.message !== prevState.alert.message
    ) {
      if (nextProps.alert.message) {
        return {
          alert: {
            ...alert,
            message: nextProps.alert.message.error,
            errorCode: nextProps.alert.message.errorCode,
            accountLocked: nextProps.alert.message.errorCode == 14
          }, submitting: false
        };
      }
      return { alert: { message: null } };
    }
    if (nextProps.user) {
      if (nextProps.user.isFirstLogin) {
        return { isFirstLogin: nextProps.user.isFirstLogin };
      }
      if (nextProps.user.isPasswordExpired) {
        return {
          alert: {
            message: nextProps.user.errMessage,
            errorCode: 1712,
            isPasswordExpired: true
          }
        };
      }
    }
    if (nextProps.error && nextProps.error.errorCode == 14) {//Account Locked
      return { accountLocked: true };
    }
    return { alert: { message: null } };
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.isFirstLogin && this.state.isFirstLogin) {
      gotoChangePassword(this.props.history, 2);
    } else if (this.props.loggedIn) {
      const { user } = this.props;
      if (user) {
        if (!user.isPasswordExpired) {
          if (this.state.tabValue === 1) {
            goToDIY(window);
          } else if (!user.isCTCL) {
            // goToEnterPin(this.props.history);
            gotoLoginWithTotp(this.props.history, this.state.username)
          } else {
            goBackToReferer(window);
          }
          // if (!user.isCTCL && this.state.tabValue === 0) {
          //   goToEnterPin(this.props.history);
          // } else {
          //   goBackToReferer(window);
          // }
        }
      }
    }
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    // this.setState({ width: window.innerWidth, height: window.innerHeight });
    if (window.innerWidth < 1000 && this.state.showImage)
      this.setState({ showImage: false });
    else if (!this.state.showImage && window.innerWidth >= 1000)
      this.setState({ showImage: true });
  };

  isRegUser = () => {
    const addr = new URL(window.location.href);
    const isRegUserParam = addr.searchParams.get('isRegUser');
    setCookieNew('tabValue', isRegUserParam || 0);
    const isRegUser = addr.searchParams.get("isRegUser") == 1;
    return isRegUser;
  }

  handleChange(e) {
    const { name, value } = e.target;
    let isUsername = name == "username";
    let newValue = !isUsername ? value : value.trim();
    const isMobile = isUsername ? this.isMobile(value) : this.state.isMobile;
    const isEmail = isUsername ? this.isEmail(value) : this.state.isEmail;

    this.setState({
      isMobile,
      isEmail,
      onSubmit: false,
      submitting: false,
      [name]: newValue,
      isEditing: true,
      alert: { message: isUsername ? validateUsername(newValue) : null }
    });
  }

  isEmail(val) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(val)) {
      return true;
    }
    return false;
  }

  isMobile(val) {
    if (/^\d{10}$/.test(val)) {
      return true;
    } else {
      return false;
    }
    return false;
  }

  handleSubmit = e => {
    e && e.preventDefault();
    const clientErr = this.state.tabValue === 1 && !(this.state.isMobile || this.state.isEmail);
    if (!this.state.alert.message /* && !clientErr */) {
      const { username, password } = this.state;
      const { dispatch } = this.props;
      if (username && password && !clientErr) {
        this.setState({ submitting: true, isEditing: false });
        dispatch(userActions.login(username, password, this.state.tabValue === 1, this.props.vendor));
      } else {
        this.setState({ onSubmit: true });
      }
    } else {
      // alert("Enter valid credentials");
      // if (clientErr) {
      //   const { dispatch } = this.props;
      //   dispatch(userActions.throwError('VALID_EMAIL_MOBILE'));
      //   // dispatch(alertActions.error('VALID_EMAIL_MOBILE'));
      //   // dispatch({ type: userConstants.LOGIN_FAILURE, error: 'VALID_EMAIL_MOBILE' });
      // }
    }
  }

  handlepasswordlink = e => {
    e && e.preventDefault();
    this.setState({ isforgotpassword: true, alert: {} });
    const { dispatch } = this.props;
    dispatch(userActions.clear());
  };

  handleLoginWithOtpLink = e => {
    e && e.preventDefault();
    if (!this.state.isMobile) {
      this.setState({ onSubmit: true });
    } else {
      gotoLoginWithOtp(this.props.history, this.state.username);
    }
  };

  handleSignUpLink = e => {
    e && e.preventDefault();
    window.location.href = `${config.diyendpoint}`;
  };

  gotoChangePassword = e => {
    e && e.preventDefault();
    gotoChangePassword(this.props.history, "2");
  };

  onTabChange = (event, newValue) => {
    setCookieNew('tabValue', newValue);
    this.setState({ tabValue: newValue, username: '', password: '', isMobile: false, isEmail: false, onSubmit: false });
  }

  render() {
    const { username, password, submitting, onSubmit } = this.state;
    const { classes, vendor } = this.props;
    const {
      TITLES: { LOGIN, FORGOT_PASS },
      LABELS: { USER_ID, MOBILE_ID, PASSWORD, SIGN_UP, LOGIN_WITH_OTP },
      ERRORS: { E_USER_ID, E_PASSWORD, VALID_EMAIL_MOBILE }
    } = strings;

    const clientErr = onSubmit && this.state.tabValue === 1 && !(this.state.isMobile || this.state.isEmail);

    let isOpen = false, popupText = "", handleClick, buttonText, accountLocked;

    if ((this.props.alert.message && this.props.alert.message.errorCode == 14)
      || (this.props.user && this.props.user.isPasswordExpired)) {
      isOpen = true;
      accountLocked = this.props.alert.message && this.props.alert.message.errorCode == 14;
      popupText = this.props.user && this.props.user.isPasswordExpired
        ? "Password Expired. Click below to set New Password"
        : "Account Locked. Click below to unlock."
      handleClick = accountLocked ? this.handlepasswordlink : this.gotoChangePassword;
      buttonText = accountLocked ? "Unlock" : "Proceed";
    }

    return (
      <>
        <AuthContainer formtype="login">
          <Box className={classes.formBox}>
            <Typography gutterBottom className={classes.formtitle} style={{ marginBottom: 10 }}>
              {`Login as${ vendor ? ' Client' : ''}`}
            </Typography>

            {!vendor && <div style={{ width: '100%', marginBottom: 10 }}>
              <StyledTabs
                value={this.state.tabValue}
                onChange={this.onTabChange}
                aria-label="full width tabs example">
                <StyledTab key={0} label={'Client'} {...a11yProps(0)} />
                <StyledTab key={1} label={'Guest User'} {...a11yProps(1)} />
              </StyledTabs>
            </div>}

            <InputPaper
              autoFocus
              inputtype="text"
              value={username}
              className={classes.divider}
              name="username"
              placeholder={this.state.tabValue == 0 ? USER_ID : MOBILE_ID}
              handler={this.handleChange}
              // image="../images/clientid.svg"
              // alt_text="client-icon"
              errorPos='top'
              // errorMsg={onSubmit && !username || clientErr ? this.state.tabValue === 1 ? VALID_EMAIL_MOBILE : E_USER_ID : null}
              errorMsg={onSubmit &&
                (this.state.tabValue === 0 && !username ? E_USER_ID
                  : this.state.tabValue === 1 && clientErr ? VALID_EMAIL_MOBILE : null)
              }
              disabled={submitting}
            />

            <InputPaper
              inputtype="password"
              value={password}
              name="password"
              placeholder={PASSWORD}
              handler={this.handleChange}
              // image="../images/lockicon.svg"
              // alt_text="lock-icon"
              errorPos='top'
              errorMsg={onSubmit && username && !clientErr && !password ? E_PASSWORD : null}
              disabled={submitting}
            ></InputPaper>

            <Typography
              className={classes.errormsg}
              variant="caption"
              display="block"
              gutterBottom
            >
              {this.state.alert.message || " "}
            </Typography>

            {this.state.tabValue === 1 && /* this.state.isMobile && */ <a
              href=""
              className={classes.fgtpasswdlink}
              style={{ paddingBottom: "10px" }}
              onClick={this.handleLoginWithOtpLink}
            >
              {LOGIN_WITH_OTP}
            </a>}

            <Button
              variant="contained"
              className={classes.loginbutton}
              onClick={this.handleSubmit}
              type="submit"
              disabled={this.state.submitting}
            >
              {LOGIN}
              {this.state.submitting ? <CircularProgress size="15" className={classes.spinner} /> : ""}
            </Button>

            <a
              href=""
              className={classes.fgtpasswdlink}
              onClick={this.handlepasswordlink}
            >
              {FORGOT_PASS}
            </a>
            {!vendor && !isCTCL() && <a
              href="#"
              className={classes.fgtpasswdlink}
              style={{ paddingTop: "10px" }}
              onClick={this.handleSignUpLink}
            >
              {SIGN_UP}
            </a>}

            {this.state.isforgotpassword
              ? gotoForgotPassword(this.props.history, username)
              : ""}
          </Box>
        </AuthContainer>
        {isOpen &&
          <CommonPopup
            // openState={true}
            openState={isOpen}
            popupText={popupText}
            handleClick={handleClick}
            buttonText={buttonText}
          />}
      </>
    );
  }
}

function mapStateToProps(state) {
  const { authentication: { loggedIn, user }, alert, logintype } = state;
  // const { alert } = state;
  return {
    loggedIn,
    alert,
    user,
    vendor: logintype?.vendor || false,
  };
}

const connectedLoginPage = connect(mapStateToProps)(withStyles(Styles)(Login));
export { connectedLoginPage as Login };

